var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoNew = function SvgLogoNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 56796",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.713,
    height: 27.532
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68826",
    d: "M7.964 22.264a1.338 1.338 0 0 1 .264-.7C6.749 19.638 2.37 14.921.596 8.914c0 .001-3.711 5.548 7.368 13.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68827",
    d: "M9.628 20.662C3.506 7.14 5.671 2.353 5.671 2.353c-1.288.107-4.455 2.22-4.249 5.123.346 4.982 5.528 11.711 7.166 13.723a3.521 3.521 0 0 1 1.04-.537Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68828",
    d: "M11.852 20.317c.132 0 .262 0 .393.01.305-4.436.871-15.428.569-18.47-.322-3.222-5.236-1.649-5.986.214-2.12 5.273 2.08 15.663 3.296 18.444a7.446 7.446 0 0 1 1.728-.198Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68829",
    d: "M12.76 20.371a6.634 6.634 0 0 1 1.075.211c2.527-5.063 4.6-11.7 4.205-16.149-.346-3.9-4.324-3.758-4.324-3.758.564 5.687-.599 16.593-.956 19.696Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68830",
    d: "M18.997 3.825c.632 6.386-3.3 14.547-4.568 16.97a2.869 2.869 0 0 1 .853.549c2.482-3.525 5.788-7.436 6.66-12.133a4.933 4.933 0 0 0-2.945-5.386Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68831",
    d: "M22.699 8.915c-.356 4.637-5.174 10.565-7.128 12.795a1.3 1.3 0 0 1 .135.34c11.933-7.242 6.993-13.135 6.993-13.135Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68832",
    d: "M11.853 20.877c-1.842 0-3.335.663-3.335 1.488a3.742 3.742 0 0 0 .257 1.461 3.026 3.026 0 0 0 .2.434 1.1 1.1 0 0 1 .174-.228 2.107 2.107 0 0 1 .673-.425 5.378 5.378 0 0 1 2.035-.359 5.888 5.888 0 0 1 1.6.208 2.587 2.587 0 0 1 1.109.576 1.129 1.129 0 0 1 .177.231 3.1 3.1 0 0 0 .2-.434 3.752 3.752 0 0 0 .258-1.461c-.012-.825-1.505-1.491-3.348-1.491Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68833",
    d: "M11.877 23.701c-1.413 0-2.559.339-2.559.758s1.146.758 2.559.758 2.559-.339 2.559-.758-1.146-.758-2.559-.758Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68834",
    d: "M12.567 26.245a16.307 16.307 0 0 0-2.085-.586c-.22-.024-.579.028-.579.459s.36 1.459 2.337 1.412c.844-.019 1.32-.213 1.432-.474s-.08-.381-1.105-.811Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 68835",
    d: "m11.498 25.751 1.871.612s.452.135.569-.158.133-.616-.353-.647-3.24-.185-2.087.193Z"
  })));
};
export default SvgLogoNew;